import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { Badge, Button, Card, CardContent, View } from "@/components/ui";
import { type ServiceProfileItem } from "@/containers/profile/service-profile/lib";
import { cn } from "@/lib/utils";

import { OtherActionsDropdown, type ActionItem } from "../other-actions-dropdown";
import { Typography } from "../typography";

export const ServiceProfileCard = ({
  profile,
  handleEdit,
  otherActions,
  onClick,
  selected,
}: {
  profile: ServiceProfileItem;
  handleEdit?: () => void;
  otherActions?: ActionItem[];
  onClick?: () => void;
  selected?: boolean;
}) => {
  const { isMobile } = useWindowDimensions();
  const editButtonText = isMobile ? "Edit" : "Edit Profile";

  return (
    <Card variant={selected ? "info" : "default"} className="flex flex-row gap-2">
      <View
        className={cn("flex flex-1 flex-col gap-1 p-4", onClick && "cursor-pointer")}
        onClick={onClick}
      >
        <View className="flex flex-row items-center gap-2">
          <Typography variant="label-sm">{profile.name}</Typography>
          {profile.isDefault && (
            <Badge size="sm" variant="primary" className="border-0">
              Default
            </Badge>
          )}
        </View>
        <View className="flex max-w-[300px] flex-row items-center">
          <Typography variant="body-sm" color="foreground-intermediate" numberOfLines={1}>
            {profile.visibleAttributes.join(" • ")}
          </Typography>
        </View>
      </View>
      <CardContent className="flex flex-row items-center justify-center gap-2">
        {handleEdit && (
          <Button
            iconName={!isMobile ? "notePencil" : undefined}
            iconColor="CTA2"
            variant="secondary"
            color="CTA2"
            size="sm"
            onClick={handleEdit}
          >
            {editButtonText}
          </Button>
        )}
        {otherActions && !profile.isDefault && <OtherActionsDropdown actions={otherActions} />}
      </CardContent>
    </Card>
  );
};
